import ProductCardV2Colors from '@components/Product/components/ProductCardV2/components/ProductCardV2Colors';
import ProductThumbnail from '@components/Product/components/ProductThumbnail/ProductThumbnail';
import { RachelProductCardsTestIds } from '../../../../../../../utils/testIds/RachelProductCards.testIds';
import {
  ProductCardsColorsConfig,
  ProductCardsPriceConfig,
  ProductCardsSummary,
} from '../../productCardsBlock.types';
import ProductCardsHeading from '../ProductCardsHeading/ProductCardsHeading';
import ProductCardsRowPrice from '../ProductCardsPrice/ProductCardsRowPrice';
import { useRachelProductRowStyles } from './rachelProductRow.styles';

interface RachelProductRowProps {
  product: ProductCardsSummary;
  colors: ProductCardsColorsConfig;
  price: ProductCardsPriceConfig;
  onClick: () => void;
}

const RachelProductRow = ({ product, colors, price, onClick }: RachelProductRowProps) => {
  const { classes } = useRachelProductRowStyles();

  return (
    <div role="listitem" test-id={RachelProductCardsTestIds.ROW} className={classes.root}>
      <div className={classes.product}>
        <div className={classes.thumbnail}>
          <ProductThumbnail url={product.imageUrl} className={classes.thumbnailMedia} />
        </div>
        <div className={classes.texts}>
          <ProductCardsHeading
            name={product.name}
            code={product.code}
            referenceCode={product.referenceCode}
            variant="row"
            onOpen={onClick}
          />
          <div className={classes.colors}>
            <ProductCardV2Colors
              allColors={colors.options}
              selectedColor={colors.selected}
              onColorClick={colors.onSelect}
            />
          </div>
        </div>
      </div>

      {price.isVisible && (
        <div className={classes.price}>
          <ProductCardsRowPrice
            prices={price.prices}
            isRetailDisabled={price.isRetailDisabled}
            isWholesaleDisabled={price.isWholesaleDisabled}
          />
        </div>
      )}
    </div>
  );
};

export default RachelProductRow;
